import {DataObjectId, Hub, taskTemplatesContainerId} from 'yougile-model'
import {globals} from '@extensions/globals-base'
import {Sync} from './sync'

export class TaskTemplateClient {
  public static hasFeature(): boolean {
    const box = Sync.get({companyId: globals.getCompanyId()})
    const container = box.get(taskTemplatesContainerId)
    return !!container
  }

  public static listTemplatesInBoard(boardId?: DataObjectId): Hub[] {
    if (!boardId) {
      return []
    }

    const box = Sync.getCurrentSandbox()

    const board = box.getHub(boardId)

    const allIds = board?.data?.taskTemplates || []
    const all = allIds.map(id => box.getHub(id))

    return all.filter(h => {
      if (!h || h.deleted) {
        return false
      }

      return true
    })
  }

  public static listTemplatesInBoardEnabled(boardId: DataObjectId): Hub[] {
    const list = this.listTemplatesInBoard(boardId)

    return list.filter(template => template.data.taskTemplate.enabled)
  }
}
